import { useMemo } from 'react';
import {
    Supercategory,
    TransactionEntryCategoryFieldsFragment,
} from '../../graphql/generated';

const useSelectedSupercategories = ({
    categoryIds,
    transactionEntryCategoriesMapById,
    defaultValues,
}: {
    categoryIds: string[] | null;
    transactionEntryCategoriesMapById: Record<
        string,
        TransactionEntryCategoryFieldsFragment
    >;
    defaultValues?: Supercategory[];
}): Supercategory[] => {
    return useMemo(() => {
        const supercategories = new Set<Supercategory>();

        if (categoryIds) {
            for (const categoryId of categoryIds) {
                const category = transactionEntryCategoriesMapById[categoryId];
                const supercategory = category?.categoryGroup.supercategory;

                if (supercategory) supercategories.add(supercategory);
            }

            return Array.from(supercategories);
        }

        // No supercategories selected; default to everything except TRANSFERS
        return defaultValues || ['INCOME', 'SPENDING', 'SAVING_INVESTING'];
    }, [categoryIds, transactionEntryCategoriesMapById, defaultValues]);
};

export default useSelectedSupercategories;
